import {forceWindowRender} from './actions/actions';
import reducer from './reducers/index';
import watch from 'redux-watch';
import {Reducer, Store} from "redux";
import {AlmeState} from "../../../wireup/AlmeState";
import Module from '../../../types/module';

export default class AlmeUiSkinner extends Module {

    constructor(passedSettings?, passedreducer: Reducer<AlmeState> | null = reducer) {
        super(passedSettings, passedreducer);
    }

    initialize(store: Store<AlmeState>): void {
        this._store = store;

        const skinStateLocation = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.Skin}`;

        const watcher = watch(this._store?.getState.bind(this), skinStateLocation);

        const defaultSkin = this._settings.skinning.defaultSkin;

        if(defaultSkin) this.handleSkinChange(defaultSkin);

        this._store.subscribe(watcher((newVal: string, oldVal: string | undefined, _objectPath: any) => {
            return this.handleSkinChange(newVal, oldVal);
        }));
    }

    handleSkinChange(newSkin: string, oldSkin?: string): void {
        const skinMap = this._settings.skinning.dataAttributes;
        
        const newSkinId = skinMap[newSkin] ?? this._settings.skinning.defaultSkin;

        const rootSelector = this._settings.skinning.rootSelector;

        const rootNode = document.querySelector(rootSelector);

        // Allows default skin to either be the skin mapping name, or the default GUID
        const defaultSkin = skinMap[this._settings.skinning.defaultSkin] ?? this._settings.skinning.defaultSkin;

        //retry if root node hasn't been rendered yet
        if (!rootNode) {
            setTimeout(() => { this.handleSkinChange(newSkin, oldSkin); }, 100);
            return;
        }

        if (!(rootNode instanceof HTMLElement)){
            return;
        }
        const dataAttrName = this._settings.skinning?.dataAttributeName ?? "skin";

        if(rootNode.dataset) {
            // Add protection for timeout function above overwriting a valid change
            if ( rootNode.dataset[dataAttrName] == oldSkin || (defaultSkin && rootNode.dataset[dataAttrName] == defaultSkin) ){
                rootNode.dataset[dataAttrName] = newSkinId;
            }
            
        } else {
            rootNode.setAttribute(`data-${dataAttrName}`, newSkinId);
        }

        if (this._settings.skinning.changeRootClass && oldSkin != undefined) {
            const oldSkinId = skinMap[oldSkin];
            this.changeRootClass(rootNode, newSkinId, oldSkinId);
        }

        //sometimes skin isn't picked up until there's a render
        this._store?.dispatch(forceWindowRender(`${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.ForceRender}`));
    }

    changeRootClass(rootNode: HTMLElement, newSkinId: string, oldSkinId: string): void {
        const newClassName = this.sanitizeClassName(newSkinId);

        if (oldSkinId) {
            const oldClassName = this.sanitizeClassName(oldSkinId);
            rootNode.classList.remove(oldClassName);
        }

        rootNode.classList.add(newClassName);
    }

    sanitizeClassName(className: string): string {
        return className.replace(/[^A-Za-z0-9]/g, '_');
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/skinner/src/skinner.ts